import React, { memo } from "react"
import { Handle, Position, NodeProps } from "@xyflow/react"
import { TriggerNodeData } from "lib/types/workflow"

import { NodeContainer, NodeHeader, NodeBody } from "./TriggerNode.styled"
import {
  StatusBadge,
  FailedMessageBlock,
  statusIcon
} from "./ExecutionOverlay.styled"
import TerminalAddButton from "./TerminalAddButton"
import { HANDLE_OUTPUT } from "../../nodeKind"

type Props = NodeProps & { id: string; data: TriggerNodeData }

const TriggerNode = memo(({ id, data }: Props) => {
  const showAddButton =
    (data._terminalHandles ?? []).includes(HANDLE_OUTPUT) && !!data._onAddAtTerminal
  const status = data._executionStatus

  return (
    <NodeContainer $skipped={status === "skipped"}>
      <NodeHeader>Trigger</NodeHeader>
      <NodeBody>{data.label}</NodeBody>
      {data._failedMessage && (
        <FailedMessageBlock>{data._failedMessage}</FailedMessageBlock>
      )}
      <Handle type="source" position={Position.Bottom} id={HANDLE_OUTPUT} />
      {showAddButton && (
        <TerminalAddButton
          onClick={() => data._onAddAtTerminal?.(id, HANDLE_OUTPUT)}
          highlighted={data._activeTerminalDropHandle === HANDLE_OUTPUT}
        />
      )}
      {status && (
        <StatusBadge $status={status}>{statusIcon(status)}</StatusBadge>
      )}
    </NodeContainer>
  )
})

TriggerNode.displayName = "TriggerNode"

export default TriggerNode
